const colors = {
  black: '#000000',
  darkGrey: '#363636',
  lightGrey: '#C2C2C2',
  white: '#FFFFFF',
  red: '#FF0000',
  darkRed: '#A10000',
  orange: '#FFA100',
  yellow: '#F8EB3E',
  green: '#269D00',
  darkGreen: '#0E3800',
  lightBlue: '#B4DDFF',
  blue: '#0000FF',
  darkBlue: '#00008E',
  purple: '#420086',
  pink: '#FF34DF',
  brown: '#642604',
  darkBrownGrey: '#322226',
  darkBlueGrey: '#25323C',
};

export default colors;
